// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const PipProductSearchResult = t.struct({
    baseMachineCode: t.String,
    comments: t.String,
    completedDate: t.maybe(t.Number),
    customerSummary: CustomerSummary,
    daysRemaining: t.Number,
    description: t.String,
    dtac: t.String,
    dtacUrl: t.String,
    expireDate: t.maybe(t.Number),
    id: t.String,
    internalRecall: t.String,
    isRepeatable: t.Bool,
    leadAccount: Dealer,
    metric: KeyValuePair,
    model: t.String,
    participant: KeyValuePair,
    pin: t.String,
    pipCompletionStatus: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    pipStatus: KeyValuePair,
    pipType: KeyValuePair,
    responsibleAccount: Dealer,
    startDate: t.maybe(t.Number),
    terminationDate: t.maybe(t.Number)
}, {
    name: 'PipProductSearchResult',
    strict: true
});

export const getDefaultState = () => new PipProductSearchResult({
    baseMachineCode: '',
    comments: '',
    completedDate: null,
    customerSummary: getCustomerSummaryDefaultState(),
    daysRemaining: 0,
    description: '',
    dtac: '',
    dtacUrl: '',
    expireDate: null,
    id: '',
    internalRecall: '',
    isRepeatable: false,
    leadAccount: getDealerDefaultState(),
    metric: getKeyValuePairDefaultState(),
    model: '',
    participant: getKeyValuePairDefaultState(),
    pin: '',
    pipCompletionStatus: getKeyValuePairDefaultState(),
    pipId: '',
    pipNumber: '',
    pipStatus: getKeyValuePairDefaultState(),
    pipType: getKeyValuePairDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    startDate: null,
    terminationDate: null
});

export default PipProductSearchResult;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-product-search-results.js